<template>
  <div class="fileInput">
    <div v-if="defaultValue||value" :style="{backgroundImage: `url(${defaultValue.replace('/', '')})`, backgroundColor: '#E8E8E8'}" @click="del"/>
    <label for="file" v-else title="點擊上傳圖片">
      請上傳圖片
      <input type="file" id="file" name="file" @change="upload" :disabled="disabled">
      <div class="insertImage">匯入圖片</div>
    </label>
  </div>

</template>

<script>
export default {
  name: 'FileInput',
  props: ['defaultValue', 'folder', 'disabled'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    }
  },
  methods: {
    del () {
      if (!this.disabled) {
        this.$emit('input', null)
      }
    },
    async upload (ev) {
      if (ev.target.files[0]) {
        const image = await this.$store.dispatch('uploadFile', { event: ev, folder: this.folder })
        console.log('upload Image', image)
        this.$emit('input', `/${this.folder}/${image.filename}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  display: inline-flex;
  width: 100%;
  height: 100%;
}
.fileInput {
  display: inline-block;
  width: 135px;
  height: 110px;
  background-color: #E8E8E8;
  border-radius: 10px;
  input[type=file] {
    display: none;
  }
  &>div:nth-child(1) {
    background-color: #FFFFFF;
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  &::before {
    content: '';
    display: inline-block;
    width: 50px;
    height: 33.64px;
    background-image: url(./svg/btn/camera.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .insertImage {
    background-color: var(--color-pri);
    height: 35px;
    border-radius: 20px;
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0;
    width: 101px;
    padding: 3px, 20px, 3px, 20px;
  }
}
</style>
